import HTTP from '@/utils/http-common';

export const getUsersByDistributorId = (distributorId) => HTTP.get(`/distributors/${distributorId}/users`);
export const getUsersRoles = () => HTTP.get(`/user-roles`);
export const updateUser = (user) => HTTP.put(`/users/${user._id}`, user);
export const updateUserField = (userId, data) => HTTP.patch(`/users/${userId}`, data);
export const updateUserSettings = (user) => HTTP.put(`/user/settings`, user);
